import { ActivatedRouteSnapshot } from '@angular/router';
import { getLastElement } from 'src/util/array';
import { isNullOrWhitespace } from 'src/util/string';

export interface RouteWithTitle {
  firstChild: RouteWithTitle | null;
  data?: {
    title?: string;
  };
}

export function getTitle(snapshot: ActivatedRouteSnapshot) {
  while (snapshot.firstChild != null) {
    snapshot = snapshot.firstChild;
  }
  return snapshot.data.title;
}

export function getTitleSegments(route: RouteWithTitle | null): string[] {
  const titleSegments: string[] = [];
  const pushTitleSegement = (rt: RouteWithTitle) => {
    if (
      rt.data != null &&
      rt.data.title != null &&
      getLastElement(titleSegments) !== rt.data.title
    ) {
      titleSegments.push(rt.data.title);
    }
  };

  // tslint:disable-next-line: no-non-null-assertion
  pushTitleSegement(route!);
  do {
    // tslint:disable-next-line: no-non-null-assertion
    route = route!.firstChild;
    // tslint:disable-next-line: no-non-null-assertion
    pushTitleSegement(route!);
    // tslint:disable-next-line: no-non-null-assertion
  } while (route!.firstChild != null);
  return titleSegments;
}

export function combineTitleSegments(titleSegements: string[]): string {
  return titleSegements.reduce(
    (parentTitleSegement, childTitleSegement) =>
      !isNullOrWhitespace(parentTitleSegement)
        ? `${childTitleSegement} - ${parentTitleSegement}`
        : childTitleSegement,
    '',
  );
}
